// components
import Button from '@components/Button/Button';
import type { FC } from 'react';

import styles from './EmailSignatureEditorImageViewMode.module.scss';

type EmailSignatureImageContainerProps = {
  onEditImage: () => void;
  onChangeImage: () => void;
  imageSrc: string;
  isLocked: boolean;
};

const EmailSignatureEditorImageViewMode: FC<React.PropsWithChildren<EmailSignatureImageContainerProps>> = ({
  onEditImage,
  onChangeImage,
  imageSrc,
  isLocked,
}) => {
  return (
    <div className={styles['image-view-mode-container']}>
      <div className={styles['image-view-mode-holder']}>
        <img className={styles['image-view-mode']} alt="email-signature" src={imageSrc} />
        <div className={styles['image-view-mode-btns-container']}>
          <Button
            disabled={isLocked}
            variant="text"
            type="default"
            onClick={(event: React.MouseEvent) => {
              event.stopPropagation();
              onChangeImage();
            }}
            size={'tiny'}
          >
            Replace
          </Button>
          <Button
            disabled={isLocked}
            variant="text"
            type="default"
            onClick={(event: React.MouseEvent) => {
              event.stopPropagation();
              onEditImage();
            }}
            size={'tiny'}
          >
            Edit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmailSignatureEditorImageViewMode;
